import { gql } from '@apollo/client';

export const NOTIFICATION_FIELDS = gql`
  fragment NotificationFields on TNotification {
    id
    title
    body
    category
    priority
    source
    status
    audienceType
    audienceAgentIds
    audienceRunIds
    actionType
    actionRunId
    scheduledAt
    publishedAt
    expiresAt
    created
    updated
    recipientCount
    pushAcceptedCount
    pushFailedCount
    noDeviceCount
    readCount
    createdByName
    isUnread
    readAt
    archivedAt
  }
`;

export const Q_MY_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS}
  query myNotifications($input: InputNotificationList!) {
    myNotifications(input: $input) {
      count
      unreadCount
      rows { ...NotificationFields }
    }
  }
`;

export const Q_ADMIN_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS}
  query adminNotifications($input: InputNotificationList!) {
    adminNotifications(input: $input) {
      count
      unreadCount
      rows { ...NotificationFields }
    }
  }
`;

export const Q_ADMIN_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  query adminNotification($input: InputId!) {
    adminNotification(input: $input) { ...NotificationFields }
  }
`;

export const Q_NOTIFICATION_AUDIENCE_PREVIEW = gql`
  query previewNotificationAudience($input: InputNotificationAudience!) {
    previewNotificationAudience(input: $input) {
      recipientCount
      pushCapableCount
      inboxOnlyCount
      sampleNames
    }
  }
`;

export const Q_NOTIFICATION_AGENT_OPTIONS = gql`
  query notificationAgentOptions($input: InputNotificationAgentSearch!) {
    notificationAgentOptions(input: $input) {
      id
      name
      email
    }
  }
`;
